module.exports = __webpack_public_path__ + "media/src/application/images/logo-v-97eb046e2f88af0c4548535a70bf8839.png";